import * as React from 'react';
import { Fade } from '@material-ui/core';

export function withTransition<P = {}>(WrappedComponent: React.ComponentType<P>): React.ComponentClass<P> {
    return class extends React.Component<P> {
        public render() {
            return (
                <Fade in={true}>
                    <div>
                        <WrappedComponent {...this.props} />
                    </div>
                </Fade>
            );
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/HOC/Transition.tsx